import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getUserProjectCodes} from 'src/openapi/admin/apis/UserProjectCodesApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useGetProjectCodes = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction: useCallback((signal: AbortSignal) => apiDispatch(
            getUserProjectCodes({userId}, {signal}),
        ), [apiDispatch, userId]),
    });
};
